

import React from 'react';

const ArrowRightUp = ({ width = 14, height = 12, color = "#1643E0" }) => (
    <svg width={width} height={height} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.48296 11.9525C4.57732 12.0445 4.70455 12.0949 4.83629 12.0925C4.96765 12.0927 5.0941 12.0426 5.18963 11.9525L11.4096 5.72663V11.0992C11.4096 11.3753 11.6335 11.5992 11.9096 11.5992C12.0439 11.6028 12.1739 11.5515 12.2695 11.4571C12.3652 11.3628 12.4182 11.2335 12.4163 11.0992V4.611C12.4336 4.53494 12.4332 4.45458 12.4132 4.37629C12.368 4.19914 12.2296 4.0608 12.0525 4.01556C11.9742 3.99557 11.8938 3.99516 11.8178 4.01249H5.32963C5.05349 4.01249 4.82963 4.23634 4.82963 4.51249C4.82963 4.78863 5.05349 5.01249 5.32963 5.01249H10.7096L4.48296 11.2392C4.38727 11.3332 4.33337 11.4617 4.33337 11.5958C4.33337 11.73 4.38727 11.8585 4.48296 11.9525Z" fill={color} />
    </svg>
);

export default ArrowRightUp;